import request from "@/utils/request";

// 商品统计
export const Goods_Acount_List = (data) => {
  return request({
    url: "/erp-pos/statistics/sale-goods",
    method: "post",
    data,
  });
};

//商品统计详情
export const Goods_Acount_Detail=(data)=>{
  return request({
      url: '/erp-pos/statistics/sale-goods-list',
      method: 'post',
      data
  })
}
// 批次统计
export const Batch_Acount=(data)=>{
  return request({
      url: '/erp-pos/statistics/batches',
      method: 'post',
      data
  })
}
//批次统计详情1
export const Batch_Acount_Detail=(data)=>{
  return request({
      url: '/erp-pos/statistics/batches-detail',
      method: 'post',
      data
  })
}
//批次统计详情2
export const Batch_Acount_GoodsDetail=(data)=>{
  return request({
      url: '/erp-pos/statistics/batches-detailtwo',
      method: 'post',
      data
  })
}
//客户统计
export const Customer_Acount=(data)=>{
  return request({
      url: '/erp-pos/statistics/get-purchase-buyers',
      method: 'post',
      data
  })
}

//客户统计详情
export const Customer_Acount_Detail=(data)=>{
  return request({
      url: '/erp-pos/statistics/sale-goods-details',
      method: 'post',
      data
  })
}
//客户统计详情2
export const Customer_Acount_goodsDetail=(data)=>{
  return request({
      url: '/erp-pos/statistics/sale-goodstwo',
      method: 'post',
      data
  })
}